import { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import "../../components/shopItemsView/shopitemview.css";
import { Row, Col, Container } from "react-bootstrap";
import BackArrow from "../../components/backArrow";
import CallIcon from "@mui/icons-material/Call";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import RedoIcon from "@mui/icons-material/Redo";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { SuccessNotify } from "../../constants/tostify";
import { FailedNotify } from "../../constants/tostify";
import url from "../../config/axios";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { getAsset } from "../../helpers/helper";
import UpdateServiceModal from "../../components/Servicemodal_one_update";
import UpdateExperienceModal from "../../components/Service_Experience_update";
import { useSearchParams } from "react-router-dom";
import { MainModal } from "@/components";

const ServiceView = () => {
  const { name } = useSelector((state) => state.user);

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type"); // "service" or "experience"

  const location = useLocation();
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);

  const { id, serviceid } = useParams(); 
  // id = serviceId OR experienceId
  // serviceid = serviceMainId

  const handleClose = () => setShows(0);

  const [Itemdata, setItemsData] = useState();
  const [show, setShow] = useState(0);
  const [shows, setShows] = useState(false);
  const [showModal, setShowModal] = useState(0);
  const [updateid, setUpdateid] = useState();

const datareturnfun=(type)=>{


   let query = `service/GetCertExpeSer/id/?id=${serviceid}`;

    if (type === "service") {
      query += `&servicesid=${id}`;
    } else {
      query += `&experienceid=${id}`;
    }

    url.get(query).then((response) => {
      setItemsData(response?.data?.data?.item);
    });

}

  useEffect(() => {
 datareturnfun(type);
  }, [type,datareturnfun]);


  const handleModal = (e) => {
    setShowModal(e);
  };

 
  const Deleteitem = () => {
    setShows(0);
    setIsloading(true);

  
    let deleteBody = {
      serviceMainId: serviceid,   
    };

    if (type === "service") {
      deleteBody.serviceId = id;
    } else {
      deleteBody.experienceId = id;
    }

    url
      .delete(`service/DeleteExpCerSer/id/`, { data: deleteBody }) 
      .then(async (response) => {
        setIsloading(false);
        if (response?.data?.message=="Deleted successfully") {
          SuccessNotify("Item Deleted Successfully");
          navigate(`/services-profile/${serviceid}`);
        } 
      })
      .catch((e) => {
        setIsloading(false);
        FailedNotify("Failed to Delete Try Again!");
      });
  };

  const [showmodal, setShowmodal] = useState(false);
  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const [showservicemodal, setShowservicemodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  useEffect(() => {
    if (Itemdata) {
      const thumimgs = document?.querySelectorAll(
        ".image-gallery-thumbnail-image"
      );
      thumimgs?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [Itemdata]);

  useEffect(() => {
    if (Itemdata) {
      const img = document?.querySelectorAll(".image-gallery-image");
      img?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [Itemdata]);

  const ShopModelCarousal =
    Itemdata?.images?.map((image, index) => ({
      id: index + 1,
      original: getAsset(image),
      thumbnail: getAsset(image),
    })) || [];

  return (
    <>
      <UpdateServiceModal
        show={showservicemodal}
        handleClose={() => setShowservicemodal(false)}
        updateid={updateid}
        serviceid={serviceid}
        datareturnfun={datareturnfun}
      />

      <UpdateExperienceModal
        show={showModal}
        handleClose={() => setShowModal(0)}
        updateid={updateid}
        serviceid={serviceid}
        datareturnfun={datareturnfun}
      />

      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />

      <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
      />

      {/* DELETE MODAL */}
      {shows === 1 && (
        <MainModal
          variant="deleteModal"
          show={shows}
          title="Delete"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem} 
        />
      )}

      <Container>
        <div className="screenHeight">
          <Row>
            <Col lg="6">
              <div className="row">
                <ImageGallery
                  showPlayButton={false}
                  showFullscreenButton={false}
                  items={ShopModelCarousal}
                />
              </div>
            </Col>

            <Col lg="6">
              <div className="ps-4 pe-4 pt-4 pb-1 bg-vilot View-Model-Shadow">
                {isloading ? (
                  <Loader heightsetting="screenHeight" />
                ) : (
                  <Row className="ps-5 pe-5">
                    <BackArrow mystyle="ps-0" />

                    <Col lg="6" md="6" sm="6" xs="6" className="mt-3">
                      <h5>{Itemdata?.heading || Itemdata?.name}</h5>
                    </Col>

                    <Col lg="6" md="6" sm="6" xs="6" className="text-end mt-3">
                      <button className="shareItembtn" onClick={handleShow}>
                        Share <RedoIcon className="share_icon_f" />
                      </button>
                    </Col>

                    <div>
                      <h6>{Itemdata?.projectName || ""}</h6>
                    </div>

                    <div>
                      <p
                        className="mb-0 font_14 text-justify"
                        style={{ lineHeight: "30px" }}
                      >
                        {Itemdata?.detail}
                      </p>
                    </div>

                    <div className="pt-4 d-flex">
                      {location.pathname === `/service-online/${id}` ? (
                        <>
                          <button className="d-flex align-items-center border rounded ps-3 pe-3 pt-1 pb-1 bg-blue text-white">
                            <ChatBubbleIcon />
                            <span className="ps-1">Message</span>
                          </button>

                          <button className="d-flex align-items-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 text-white">
                            <CallIcon />
                            <span className="ps-1">Call</span>
                          </button>
                        </>
                      ) : (
                        <>
                          {/* DELETE BUTTON */}
                          <button
                            className="d-flex align-items-center border rounded ps-3 pe-3 pt-1 pb-1 bg-red text-white"
                            onClick={() => setShows(1)}
                          >
                            <DeleteOutlineOutlinedIcon />
                            <span className="ps-1">Delete</span>
                          </button>

                          {/* EDIT BUTTON */}
                          {Itemdata?.projectName ? (
                            <button
                              className="d-flex align-items-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 text-white"
                              onClick={() => {
                                setUpdateid(Itemdata?._id);
                                handleModal(6);
                              }}
                            >
                              <CreateOutlinedIcon />
                              <span className="ps-1">Edit</span>
                            </button>
                          ) : (
                            <button
                              className="d-flex align-items-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 text-white"
                              onClick={() => {
                                setUpdateid(Itemdata?._id);
                                setShowservicemodal(true);
                              }}
                            >
                              <CreateOutlinedIcon />
                              <span className="ps-1">Edit</span>
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </Row>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default ServiceView;
